"use strict";
const Numeral = require('numeral');
const formatNumbers = (n, args) => {
    const numeral = Numeral(n);
    let format;
    const formatArgs = (args === null || args === undefined) ? '0,0' : args;
    if (typeof args === 'string') {
        format = formatArgs;
    }
    else {
        format = (formatArgs !== null && typeof formatArgs.format === 'string' ? formatArgs.format : '0,0');
    }
    // Setup the optional parameters
    if (formatArgs !== null) {
        Numeral.zeroFormat(formatArgs.zeroFormat || '0');
    }
    return numeral.format(format).toUpperCase();
};
module.exports = {
    formatNumbers,
};
//# sourceMappingURL=formatNumbers.js.map